import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceTypeDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ServiceTypeApiClient extends BaseCRUDApiClient<ServiceTypeDtoModel> {
  baseUrl = this.config.apiEndpoint + '/service-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
